import { render, staticRenderFns } from "./ArtigosTabelaBuscar.vue?vue&type=template&id=64614609"
import script from "./ArtigosTabelaBuscar.vue?vue&type=script&lang=js"
export * from "./ArtigosTabelaBuscar.vue?vue&type=script&lang=js"
import style0 from "./ArtigosTabelaBuscar.vue?vue&type=style&index=0&id=64614609&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports